import { httpsCallable } from "firebase/functions"
import { EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth"
import { auth, functions } from "@/common/lib/firebase/firebase"

export const recoveryEnabled = import.meta.env.VITE_RECOVERY_ENABLED === "true"
export const recoveryPath = "/auth/recovery"
export const confirmRecoveryPath = `${recoveryPath}/confirm`
// Capture once before router/telemetry initialization; never put the token in a query key or log.
export const initialRecoveryToken =
    window.location.pathname === confirmRecoveryPath
        ? window.location.hash.slice(1)
        : ""
if (initialRecoveryToken)
    window.history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search
    )

export type RecoveryContact = {
    email: string
    verified: boolean
    pending: boolean
}
export type MailAttempt = {
    id: string
    kind: string
    state: string
    attempts: number
}
export type RecoveryRequest = {
    id: string
    uid: string
    originalEmail: string
    replacementEmail: string
    firstName: string
    lastName: string
    status: string
    expiresAt: number
    replacementVerifiedAt: number | null
    secondaryConfirmedAt: number | null
    contactEmail: string | null
    contactCurrent: boolean
    reviewedBy?: string
    verificationMethod?: string
    manualEvidence?: { independentContact: string; writtenAuthority: string }
    reason?: string
    notifications: MailAttempt[]
}
export type RecoveryPage = {
    requests: RecoveryRequest[]
    nextCursor: string | null
    operations: {
        id: string
        uid: string
        status: string
        failedStep?: number
    }[]
    passwordNotifications: { id: string; uid: string; status: string }[]
    failedNotifications: MailAttempt[]
}
export async function recoveryCall<T>(
    name: string,
    input: unknown = {}
): Promise<T> {
    return (await httpsCallable<unknown, T>(functions, name)(input)).data
}
export async function reauthenticate(password: string) {
    const user = auth.currentUser
    if (!user?.email) throw new Error("Please sign in again")
    await reauthenticateWithCredential(
        user,
        EmailAuthProvider.credential(user.email, password)
    )
    await user.getIdToken(true)
}
